import { render, staticRenderFns } from "./Zooy.vue?vue&type=template&id=35b1fea7&scoped=true&"
import script from "./Zooy.vue?vue&type=script&lang=ts&"
export * from "./Zooy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b1fea7",
  null
  
)

export default component.exports